import { useQuery } from "@apollo/client";
import { Box, Heading, Image, Skeleton, Text, VStack } from "@chakra-ui/react";
import { colors } from "../Theme";
import Loader from "./Helpers/Loader";
import { useAppDispatch } from "../Store/hooks";
import { setProjectId } from "../Store/GlobalReducer";
import { StarIcon } from "@chakra-ui/icons";
import {
  LOAD_PROJECTS,
} from "./Queries";
import {
  ProjectPayload,
  ProjectProps,
} from "./Modals/Projects/Types";

const ProjectBox = (props: ProjectProps) => {
  const dispatch = useAppDispatch();
  return (
    <Box pos="relative">
      {props.isFavorite && (
        <StarIcon
          boxSize="2rem"
          pos="absolute"
          color="yellow"
          top=".5rem"
          right=".5rem"
        />
      )}
      <Image
        src={props.preview}
        alt={props.name}
        fallback={<Skeleton w={200} h={150} />}
        onClick={() => dispatch(setProjectId(props.id))}
      />
    </Box>
  );
};

const Projects = (props: {
  projects: ProjectProps[];
  favorites: ProjectProps[];
  published: ProjectProps[];
}) => {
  let result: ProjectProps[] = [];
  let addedIds: number[] = [];

  for (var i = 0; i < props.favorites.length && result.length < 5; i++) {
    const item: ProjectProps = props.favorites[i];
    result.push(item);
    addedIds.push(item.id);
  }

  for (i = 0; i < props.published.length && result.length < 5; i++) {
    const item: ProjectProps = props.published[i];
    if (addedIds.indexOf(item.id) === -1) {
      result.push(item);
      addedIds.push(item.id);
    }
  }

  for (i = 0; i < props.projects.length && result.length < 5; i++) {
    const item: ProjectProps = props.projects[i];
    if (addedIds.indexOf(item.id) === -1) {
      result.push(item);
      addedIds.push(item.id);
    }
  }

  return (
    <VStack overflowY="auto" maxH="100%">
      {result.map((project: ProjectProps) => (
        <ProjectBox {...project} key={`lproject${project.id}`} />
      ))}
    </VStack>
  );
};

const Left = () => {
  const favData = useQuery<{ projects: ProjectPayload }>(LOAD_PROJECTS, {
    variables: { favorite: true, published: false },
  });
  const pubData = useQuery<{ projects: ProjectPayload }>(LOAD_PROJECTS, {
    variables: { favorite: false, published: true },
  });
  const data = useQuery<{ projects: ProjectPayload }>(LOAD_PROJECTS, {
    variables: { favorite: false, published: false },
  });

  let loading = favData.loading || pubData.loading || data.loading;
  let error = null;
  if (favData.error) error = favData.error.message;
  if (pubData.error) error = pubData.error.message;
  if (data.error) error = data.error.message;
  if (!data.data || !favData.data || !pubData.data) loading = true;
  return (
    <Box width="12%" h="100vh" bg={colors.badgeLight}>
      <Heading size="md" variant="editor" textAlign="center">
        Проекты
      </Heading>
      {loading && <Loader />}
      {error && <Text>Error: {error}</Text>}
      {!loading && (
        <Projects
            projects={data.data ? data.data.projects.items : []}
            favorites={favData.data ? favData.data.projects.items : []}
            published={pubData.data ? pubData.data.projects.items : []}
        />
      )}
    </Box>
  );
};

export default Left;
